<!-- 
  編集メイン画面
-->
<template>
  <div class="container-fluid">
    <Loading v-if="this.$store.state.isLoading" />
    <AlertDialog v-if="this.$store.state.isAlertDialog" />
    <div class="row header bt-primary justify-content-between align-items-center">
      <div class="col-auto">
        <img
          class="titleimg"
          src="@/assets/acrypro/ambi_logo.png"
          width="100px"
          style="cursor: pointer"
          @click="backhome"
        />
      </div>
    </div>
    <div class="row" style="height: 40px"></div>
    <div class="row">
      <div class="col text-center">
        <p class="noto acry-foreground h3 fw-bold">お問い合わせを受け付けました</p>
      </div>
    </div>

    <div class="row justify-content-center mt-4 p-3 m-auto">
      <p class="m-0">２〜３営業日以内に担当者よりご連絡いたします。</p>
      <p class="m-0">ご連絡まで今しばらくお待ちください。</p>
    </div>

    <div class="row justify-content-center m-auto p-3 text-start" style="width: 600px">
      <p class="m-0">
        ・<span style="font-weight: bold">support@acry.co.jp</span>からお送りします
      </p>
      <p class="m-0">
        ・メールが届かない場合は、メールアドレスが間違っているか、迷惑メールフォルダに届いてしまっている可能性があります。
      </p>
    </div>

    <div class="row justify-content-center my-3">
      <button type="button" class="border-0 acry-normal-btn" @click="backhome">
        <span class="fw-bold">TOPへ戻る</span>
      </button>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "ContactFormComplete",
  components: {},
  data() {
    return {
      userName: "",
      userKana: "",
      userEmail: "",
      userContent: "",
      userNameError: false,
      userKanaError: false,
      userEmailError: false,
      userContentError: false,
    };
  },
  async mounted() {},
  created: function () {},
  destroyed() {},
  watch: {
    userName() {
      this.userNameError = false;
    },
    userKana() {
      this.userKanaError = false;
    },
    userEmail() {
      this.userEmailError = false;
    },
    userContent() {
      this.userContentError = false;
    },
  },
  methods: {
    backhome() {
      router.push("/");
    },
    inputCheck() {
      var errorExist = false;
      if (!this.userName) {
        errorExist = true;
        this.userNameError = true;
      }
      if (!this.userKana) {
        errorExist = true;
        this.userKanaError = true;
      }
      if (!this.userEmail) {
        errorExist = true;
        this.userEmailError = true;
      }
      if (!this.userContent) {
        errorExist = true;
        this.userContentError = true;
      }

      return !errorExist;
    },
    sendAction() {
      if (!this.inputCheck()) {
        return;
      }
    },
  },
  computed: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mustlbl {
  color: white;
  background: #bc6665;
  border-radius: 3px;
  padding: 5px 12px 5px 12px;
}
.acry-input {
  width: 300px;
  height: 40px;
  padding-left: 10px;
}
.acry-textarea {
  border: solid #cdcdcd 1px;
  border-radius: 4px;
  width: 100%;
  height: 200px;
  padding-left: 10px;
}
.acry-input-error {
  border: 1px solid #bc6665;
}
</style>
